import { ClipCompositionStatusType } from './types';
import { STATUS_STYLES } from './ClipCompositionStatusConstants';
import UserNamesList from './UserNamesList';
import { classnames } from '@/libs/utils';
import Icon from '@/components/atoms/Icon';

export function ClipCompositionStatus({
  clipCompositionStatus,
  affectedClipCompositionUsers
}: {
  clipCompositionStatus: ClipCompositionStatusType;
  affectedClipCompositionUsers: string[];
}) {
  if (clipCompositionStatus === 'done') {
    return null;
  }

  const style = STATUS_STYLES[clipCompositionStatus];
  const messageParts = style.message.split('{{names}}');

  return (
    <div
      className={classnames(
        'mb-2 flex items-center gap-x-4 rounded-md px-3 py-2 text-sm',
        style.bgColor,
        style.textColor
      )}
    >
      <Icon name={style.icon} size={32} className="w-16" />
      <span>
        {messageParts[0]}
        {!!messageParts[1] && (
          <>
            <UserNamesList userNames={affectedClipCompositionUsers} />
            {messageParts[1]}
          </>
        )}
      </span>
    </div>
  );
}

export default ClipCompositionStatus;
